import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, getDocs, getDoc, doc, query, where, updateDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDo8_KL3G5nJpjP72a5UfZse7Q2W3ob4aU",
  authDomain: "musaffosayohat-a708c.firebaseapp.com",
  projectId: "musaffosayohat-a708c",
  storageBucket: "musaffosayohat-a708c.firebasestorage.app",
  messagingSenderId: "858479224962",
  appId: "1:858479224962:web:c00a48d032dc6f94f62c9b"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export function addItem(table, data){
  return new Promise((resolve, reject) => {
    addDoc(collection(db, String(table)), data)
      .then(data => {
        resolve(data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function getItems(table){
  return new Promise((resolve, reject) => {
    getDocs(collection(db, String(table)))
      .then(data => {
        let arrayList =[];
        data.forEach(item => {
          arrayList.push({ id: item.id, ...item.data() });
          resolve(arrayList);
        })
      })
      .catch(err => {
        reject(err)
      })
  })
}


